import * as React from "react";
import { connect } from "react-redux";
import { Theme, createStyles } from '@mui/material/styles';;
import { withStyles, WithStyles } from '@mui/styles';;
import idssStyle from "../../../Configuration/SharedStyling";
import {
    IGenericUserProps,
    genericMapStateToProps
} from "../../../DataClasses/GenericUser";
import { Grid2 as Grid } from "@mui/material";
import BackNavigation from '../../Shared/BackNavigation';
import SharedMaterialReactTable, { ISharedTableColumn } from "../../Shared/MaterialReactTable";
import { IEvent } from "../../../DataClasses/DbData";
import { AjaxError } from "rxjs/ajax";
import { firstValueFrom } from "rxjs";
import ReportsService from "../../Services/ReportsService";
import DateDisplay from '../../Shared/DateDisplay';
import { Redirect } from "react-router-dom";

const styles = (theme: Theme) => createStyles({ ...idssStyle(theme) });

interface IActivityReportState {
    data: any[];
    isLoading: boolean;
    redirect: boolean;
}

type IStylesProps = WithStyles<typeof styles>;

// VIEW
class ActivityReportView extends React.Component<
    IGenericUserProps & IStylesProps,
    IActivityReportState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            data: [],
            isLoading: true,
            redirect: false
        };
    }

    public componentDidMount() {
        this.RefreshModel();
    }

    private redirectToErrorPage() {
        return <Redirect to='/errorpage' />;
    }

    private setRedirectState() {
        this.setState({ redirect: true });
    }

    private dateBodyTemplate = (rowData: any) => {
        return (
            <DateDisplay format="YYYY/MM/DD">
                {rowData.date}
            </DateDisplay>
        );
    };

    private getTableColumns = (): ISharedTableColumn<any>[] => [
        {
            accessorKey: 'date',
            header: 'Date',
            enableSorting: true,
            enableFiltering: false,
            Cell: ({ row }) => this.dateBodyTemplate(row.original),
        },
        {
            accessorKey: 'user',
            header: 'User',
            enableSorting: true,
            enableFiltering: true,
        },
        {
            accessorKey: 'orgId',
            header: 'Org ID',
            enableSorting: true,
            enableFiltering: true,
        },
        {
            accessorKey: 'subId',
            header: 'Sub ID',
            enableSorting: true,
            enableFiltering: true,
        },
        {
            accessorKey: 'component',
            header: 'Component',
            enableSorting: true,
            enableFiltering: true,
        },
        {
            accessorKey: 'message',
            header: 'Message',
            enableSorting: true,
            enableFiltering: false,
        },
    ];

    public render() {
        if (this.state.redirect) {
            return this.redirectToErrorPage();
        }

        const { classes } = this.props;
        return (

            <Grid container={true} className={classes.gridRowFlex} spacing={0}>
                <Grid size={12}>
                    <Grid container={true} spacing={2}>
                        <Grid size={12}>
                            <BackNavigation text="Back to Reports" href="/reportspage" />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={12}>
                    <div className={classes.card}>
                        <SharedMaterialReactTable
                            data={this.state.data}
                            columns={this.getTableColumns()}
                            title="Activities Report"
                            isLoading={this.state.isLoading}
                            enablePagination={true}
                            enableSorting={true}
                            enableFiltering={true}
                            enableColumnActions={true}
                            enableRowActions={false}
                            initialState={{
                                pagination: { pageIndex: 0, pageSize: 20 },
                            }}
                            muiPaginationProps={{
                                rowsPerPageOptions: [10, 15, 20, 25, 50, 75, 100, 500, 1000],
                            }}
                            emptyMessage="No activities found."
                        />
                    </div>
                </Grid>
            </Grid>
        );
    }

    private async RefreshModel() {
        this.setState({ isLoading: true });
        const retval: IEvent[] | AjaxError = await firstValueFrom(
            ReportsService.GetEventListCaller$(this.props.user)
        );
        if (retval instanceof AjaxError || !retval) {
            this.setRedirectState();
        } else {
            this.setState({
                data: retval.map(item => ({
                    date: item.timestamp,
                    user: item.user,
                    orgId: item.orgId,
                    subId: item.subId,
                    component: item.displayComponent,
                    message: item.message
                }))
            });
        }
        this.setState({ isLoading: false });
    }
}

// REDUX CONTAINER
const ActivityReportPageWithState = connect<IGenericUserProps>(
    genericMapStateToProps
)(ActivityReportView);

// STYLES CONTAINER
const ActivityReportPage = withStyles(styles)(
    ActivityReportPageWithState
);

export default ActivityReportPage;
